import Typography from "@mui/material/Typography";

export type WeightDisplayProps = {
    value?: number | null;
};

export function WeightDisplay({ value }: WeightDisplayProps) {
    if (value == null || value === 0) {
        return <Typography component="span">—</Typography>;
    }

    if (value < 1000) {
        return <Typography component="span">{value} g</Typography>;
    }

    const kg = value / 1000;
    return <Typography component="span">{kg.toFixed(1)} kg</Typography>;
}
